import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import { marketplaceReducer } from './marketplace/marketplace-reducer';
import { rootSaga } from './root-saga';

const middleware = createSagaMiddleware();
const middlewareEnhancers = applyMiddleware(middleware);
const enhancers = [middlewareEnhancers];
const composedEnhancers = composeWithDevTools(...enhancers);

export const rootReducer = combineReducers({
  marketplace: marketplaceReducer,
});

export const store = createStore(rootReducer, composedEnhancers);

middleware.run(rootSaga);
